// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2i2kB","productName":"Table_productName__2JJdr"};